import { PlanDetails, PlansDetails } from '../typings/plans';

type Promotions = PlanDetails['promotions'];

interface AddPlanPromoDetails {
  dealText?: string;
  marketingTag?: string;
}

export function getMarketingTag(promotions: Promotions) {
  return promotions?.find((promo) => promo?.productType === 'MARKETING');
}

export function getPromoOffer(promotions: Promotions) {
  return promotions?.find((promo) => promo?.productType === 'DEAL');
}

export function getSortedPromoCharacteristics(promotions: Promotions) {
  return promotions
    ?.filter((promo) => promo?.productType === 'CHARACTERISTIC')
    ?.sort((a, b) => Number(a.sortOrder) - Number(b.sortOrder));
}

export function hasMarketingTag(productOffers: PlansDetails) {
  return productOffers.some((offer) => getMarketingTag(offer.promotions));
}

export function getTrackingPromoDetails(
  promotions: Promotions,
): AddPlanPromoDetails {
  return {
    dealText: getPromoOffer(promotions)?.name,
    marketingTag: getMarketingTag(promotions)?.name,
  };
}
